if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.productQty = this.dataset.productQty;
      this.productId = this.dataset.productId;
    }

    async prepareCartForAdd() {
      const formData = JSON.parse(serializeForm(this.form));

      return prepareCartForAdd({
        productId: this.productId,
        productQty: this.productQty,
        variantId: formData.id,
        quantity: formData.quantity || 1,
      });
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      try {
        if (this.productQty && this.productId) {
          const canAdd = await this.prepareCartForAdd();
          if (!canAdd) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            return;
          }
        }
      } catch (e) {
        console.error(e);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        return;
      }

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}
